import React, { useEffect, useState } from "react";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef, IFormItem } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { useMarketingListModel } from "../allMemberMarketingListModel";
import { noticeService } from "../../../notice/NoticeService";
import { OptionDsType } from "@src/types/FmsTypes";
import { IMarketingRecordDetail } from "../allMemberMarketingListTypes";
import { allMemberMarketingListService } from "../allMemberMarketingListService";
import { globalPrompt } from "@src/components/YhMessage";
import { useLockFn } from "ahooks";
import { httpRequest } from "@utils/HttpRequest";
import { momentFormats } from "@src/utils/utils";
import { YhBut } from "@src/components/YhButton";
import { Button } from "antd";
import { AuditRecordDrawer } from "./AuditRecordDrawer";

export function DetailDrawer() {
	const {
		drawerVisible,
		setDrawerVisible,
		editType,
		selectedRow,
		loadData,
	} = useMarketingListModel();

	const formRef = React.useRef<IYhFormRef>();
	const [userList, setUserList] = useState<(OptionDsType & { id: string })[]>([]);
	const [loading, setLoading] = useState(false);
	const [auditRecordVisible, setAuditRecordVisible] = useState(false);

	useEffect(() => {
		if (drawerVisible) {
			if (editType === 'edit' || editType === 'look' && selectedRow) {
				formRef.current?.setFieldsValue({
					...selectedRow,
					createTime: momentFormats(selectedRow.createTime as string),
					validTime: momentFormats(selectedRow.validTime as string),
				});
			} else if (editType === 'add') {
				formRef.current?.resetFields();
				formRef.current?.setFieldsValue({
					status: true,
				});
			} else {
				formRef.current?.resetFields();
			}
		}
	}, [drawerVisible, editType, selectedRow]);


	const onCancel = () => {
		setDrawerVisible(false);
		formRef.current?.resetFields();
	};

	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 4 },
		disabled: true,
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "客户名称",
				fieldName: "customerName",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "营销类型",
				fieldName: "typeName",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "负责人",
				fieldName: "controller",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "联系电话",
				fieldName: "controllerPhone",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "主要决策人",
				fieldName: "decisionMaker",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "联系电话",
				fieldName: "decisionMakerPhone",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "业务联系人",
				fieldName: "businessContact",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "联系电话",
				fieldName: "businessContactPhone",
				span: 24,
			},
			{
				type: FormItemTypeEnum.TextArea,
				fieldLabel: "用户需求",
				fieldName: "userRequirement",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "对接到主营业务单位的具体负责人",
				fieldName: "specificPerson",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "收入分配办法及具体金额",
				fieldName: "allocationAmount",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "信息有效期",
				fieldName: "validTime",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "立项副营编号",
				fieldName: "proposalNo",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "创建人",
				fieldName: "createUser",
				span: 24,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "创建时间",
				fieldName: "createTime",
				span: 24,
			},
		] as IFormItem[],
	};

	return (
		<>
			<YHDrawer
				title={editType === 'add' ? "新增" : editType === 'look' ? "查看" : "编辑"}
				visible={drawerVisible}
				onCancel={onCancel}
				footerButs={[]}
				width={600}
				showFooter={false}
			>	
					 <Button
						className="mr-5"
						type="link"
						shape="round"
						onClick={() => setAuditRecordVisible(true)}
					>审批记录</Button>
				<YhForm {...formConfig} />
			</YHDrawer>
			<AuditRecordDrawer
				visible={auditRecordVisible}
				onClose={() => setAuditRecordVisible(false)}
				auditInstanceList={selectedRow?.auditInstanceList}
			/>
		</>
	);
}
